<template>
    <CardToggle :title="$t('player.layout.page')">
        <div class="space-y-5">
            <FormInput
                :title="$t('player.layout.page_title')"
                :placeholder="$t('player.layout.company_name')"
                v-model="player.pageTitle"
            />
            <div id="playerLogo">
                <FormFiles
                    :title="$t('player.layout.page_icon')"
                    :labels="{
                        clickToUpload: $t('shared.uploader.click_to_upload'),
                        dragAndDrop: $t('shared.uploader.drag_and_drop'),
                        fileInfo: $t('shared.uploader.file_details'),
                    }"
                    :maxSize="10000"
                    :errorMessages="{
                        invalidSize: $t('shared.invalid.file_size_over'),
                        invalidType: $t('shared.invalid.file_type'),
                    }"
                    :single-file="true"
                    v-model="files"
                    @fileSelected="uploadImage"
                    @fileRemoved="removeImage"
                />
            </div>
            <FormInput
                id="playerSideTitle"
                :title="$t('player.layout.sidebar_heading')"
                :placeholder="$t('player.layout.files_list')"
                v-model="player.sideTitle"
            />
            <FormInput
                id="playerNextBtnTitle"
                :title="$t('player.layout.next_file_label')"
                :placeholder="$t('player.layout.next_file')"
                v-model="player.nextBtnTitle"
            />
            <FormInput
                id="playerPrevBtnTitle"
                :title="$t('player.layout.prev_file_label')"
                :placeholder="$t('player.layout.prev_file')"
                v-model="player.prevBtnTitle"
            />
            <FormInput
                id="playerMarkDoneLabel"
                :title="$t('player.layout.mark_done_label')"
                v-model="player.markDoneLabel"
            />

            <FormInput :title="$t('player.layout.finished_label')" v-model="player.finishedLabel" />
        </div>
    </CardToggle>
</template>

<script>
import { mapState, mapActions } from "vuex";

import { CardToggle } from "@easy/ui/cards";
import { FormInput, FormFiles, makeFileModel } from "@easy/ui/forms";
import { useFocusOnQueryField } from "@/shared/utils/forms/useFocusOnQueryField";

export default {
    components: {
        CardToggle,
        FormInput,
        FormFiles,
    },
    setup() {
        useFocusOnQueryField();
    },
    computed: {
        ...mapState("player", ["player"]),
    },
    data() {
        return {
            files: [],
        };
    },
    watch: {
        player: {
            handler(player, oldPlayer) {
                if (!oldPlayer?.pageIcon && player?.pageIcon) {
                    this.files = [
                        makeFileModel({
                            url: player.pageIcon,
                        }),
                    ];
                }
            },
            immediate: true,
            deep: true,
        },
    },
    methods: {
        ...mapActions("player", ["uploadIcon"]),
        removeImage() {
            this.player.pageIcon = "";
        },
        uploadImage($event) {
            this.uploadIcon({ file: $event });
        },
    },
};
</script>
